import React, { Component } from 'react';
import './styles.scss';

class Form extends Component {
	render() {
		const { className, children, style } = this.props;
		return (
			<div style={style} className={`${className} Form`}>
				{children}
			</div>
		);
	}
}
class FormClose extends Component {
	render() {
		const { onClickClose, children } = this.props;
		return (
			<button className="Form-close" onClick={onClickClose}>
				{children || 'Close'}
			</button>
		);
	}
}
class FormTitle extends Component {
	render() {
		const { children } = this.props;
		return <h2 className="Form-title">{children}</h2>;
	}
}
class FormContent extends Component {
	render() {
		const { children } = this.props;
		return <div className="Form-content">{children}</div>;
	}
}
class FormButton extends Component {
	render() {
		const { disabled, onClick, children } = this.props;
		return (
			<div className="Form-button-container">
				<button className="Form-button" disabled={disabled} onClick={onClick}>
					{children}
				</button>
			</div>
		);
	}
}
class FormInput extends Component {
	render() {
		const { className } = this.props;
		return <input {...this.props} className={`Form-input ${className}`} />;
	}
}

export { Form, FormTitle, FormContent, FormClose, FormButton, FormInput };
